import React, { useState } from 'react';
import styled from 'styled-components';
import { TextRegular14 } from './Text';
import Flex from './Flex';

export const ExpandableText: React.FC<{
  maxLength?: number;
  linesFolded?: number;
}> = ({ linesFolded = 3, maxLength = 150, children }) => {
  const tooShortToFold = !!(
    typeof children === 'string' && children.length < maxLength
  );

  const [expanded, setExpanded] = useState(tooShortToFold);

  return (
    <Flex flexDirection="column">
      <BiographyWrapper expanded={expanded} linesFolded={linesFolded}>
        {children}
      </BiographyWrapper>
      {!tooShortToFold && (
        <TextRegular14
          style={{ cursor: 'pointer', fontWeight: 'bold', marginTop: 4 }}
          onClick={() => setExpanded((val) => !val)}
        >
          {expanded ? 'show less' : 'show more'}
        </TextRegular14>
      )}
    </Flex>
  );
};

const BiographyWrapper = styled(TextRegular14)<{
  expanded: boolean;
  linesFolded: number;
}>`
  display: -webkit-box;
  -webkit-line-clamp: ${(p) => (p.expanded ? '' : p.linesFolded)};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
